import React, { PropTypes, Component } from 'react'
import constants from 'constants'
import { Progress } from '.'
// import moment from 'moment'
import { format } from 'date-fns'

class UploadPlan extends Component {
    static propTypes = {
      currentUser: PropTypes.object.isRequired,
      handleOpenDialog: PropTypes.func.isRequired,
      handleUpload: PropTypes.func.isRequired,
      partnerPlan: PropTypes.object.isRequired,
      selectedPlan: PropTypes.object.isRequired,
    }

    render() {
      const {
        currentUser,
        partnerPlan,
        selectedPlan,
        handleUpload,
        handleOpenDialog,
      } = this.props

      const steps = [
        {
          key: 1,
          label: constants.PARTNERPLAN.STEPS.DRAFT,
          desc: `${partnerPlan.partnerPlan.planStatus}: ${format(new Date(partnerPlan.partnerPlan.planUploadedDate), constants.DATE_FORMAT.PARTNER_PLAN_FORM)}`,
          isDone: true,
          isCurrent: false,
          actions: [
            {
              label: 'OVERWRITE',
              onClick: handleUpload,
              active: true,
              show: (selectedPlan.Role === constants.PARTNERPLAN.ROLE.MYPLANS && currentUser.IsAdmin === true),
            },
          ],
        },
        {
          key: 2,
          label: constants.PARTNERPLAN.STEPS.SUBMIT,
          desc: 'Pending',
          isDone: false,
          isCurrent: true,
          actions: [
            {
              label: 'SUBMIT',
              onClick: handleOpenDialog,
              active: true,
              show: (selectedPlan.Role === constants.PARTNERPLAN.ROLE.MYPLANS),
            },
          ],
        },
        {
          key: 3,
          label: constants.PARTNERPLAN.STEPS.AGREED,
          desc: '',
          isDone: false,
          isCurrent: false,
          actions: [],
        },
        {
          key: 4,
          label: constants.PARTNERPLAN.STEPS.INTERIM_ASSESSMENT,
          desc: '',
          isDone: false,
          isCurrent: false,
          actions: [],
        },
        {
          key: 5,
          label: constants.PARTNERPLAN.STEPS.INTERIM_ASSESSMENT_SUBMITTED,
          desc: '',
          isDone: false,
          isCurrent: false,
          actions: [],
        },
        {
          key: 6,
          label: constants.PARTNERPLAN.STEPS.INTERIM_ASSESSMENT_AGREED,
          desc: '',
          isDone: false,
          isCurrent: false,
          actions: [],
        },
        {
          key: 7,
          label: constants.PARTNERPLAN.STEPS.FINAL_ASSESSMENT,
          desc: '',
          isDone: false,
          isCurrent: false,
          actions: [],
        },
        {
          key: 8,
          label: constants.PARTNERPLAN.STEPS.FINAL_ASSESSMENT_SUBMITTED,
          desc: '',
          isDone: false,
          isCurrent: false,
          actions: [],
        },
        {
          key: 9,
          label: constants.PARTNERPLAN.STEPS.FINAL_ASSESSMENT_AGREED,
          desc: '',
          isDone: false,
          isCurrent: false,
          actions: [],
        },
      ]

      return (
        <Progress steps={steps} />
      )
    }
}

export default UploadPlan



// WEBPACK FOOTER //
// ./src/views/PartnerPlans/components/Progress/UploadPlan.js